import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';

import { dispatchOpenEmbedWidgetPopup } from '../../../store/modals/actions';
import { WIDGET_NAMES } from '../../../utils/constant';

import classes from './index.module.css';

const propTypes = {
  embedWidgetType: PropTypes.oneOf(Object.values(WIDGET_NAMES)).isRequired,

  isEmbeddable: PropTypes.bool,
  isWidget: PropTypes.bool,
  widgetAddContent: PropTypes.any,
  embedWidgetUrl: PropTypes.string,

  dispatchOpenEmbedWidgetPopup: PropTypes.func.isRequired,
  isEmbedWidgetOpen: PropTypes.bool.isRequired,

  legendTooltip: PropTypes.objectOf(PropTypes.any),
  legendLabelsCallback: PropTypes.func,

  name: PropTypes.string.isRequired,
};

const defaultProps = {
  isEmbeddable: false,
  isWidget: false,
  widgetAddContent: '',
  embedWidgetUrl: '',
  legendTooltip: {
    title: '',
    valueFormatFunc: () => {},
  },
  legendLabelsCallback: () => {},
};

class CountyMapFooter extends Component {
  getMapFooterView = () => {
    const { openEmbedWidgetPopup, getMapLegendView } = this;
    const { widgetAddContent, isEmbeddable, isWidget, isEmbedWidgetOpen, name, embedName } =
      this.props;
    const mapLegendView = getMapLegendView();

    return (
      <div className={classes['county-map-footer']}>
        {isEmbeddable && (
          <div className={classes['county-map-embed-buttons']}>
            <ZpButton
              theme={`${isEmbedWidgetOpen && embedName === name ? 'primary' : 'secondary'}`}
              type="button"
              onClick={openEmbedWidgetPopup}
            >
              Embed On Your Website
            </ZpButton>
          </div>
        )}
        {isWidget && widgetAddContent ? widgetAddContent : ''}
        {mapLegendView}
      </div>
    );
  };

  onLegendBarClick = (e) => {
    const { onLegendBarHover } = this;
    onLegendBarHover(e);
  };

  onLegendBarHover = (e) => {
    const { target } = e;
    const { onLabelLegendSelect } = this.props;
    const id = target.dataset.id;
    onLabelLegendSelect(id);
  };

  onLegendBarLeave = () => {
    const { onLabelLegendSelect } = this.props;
    onLabelLegendSelect('');
  };

  getMapLegendView = () => {
    const { onLegendBarClick, onLegendBarHover, onLegendBarLeave, getLegendTooltipView } = this;

    const { svg, legendTooltip, legendLabelsCallback } = this.props;

    const { title, valueFormatFunc } = legendTooltip || {};

    if (!svg || !svg.children || svg.children.length < 3) {
      return <></>;
    }

    const styles = svg.children[0].innerHTML || '';
    const ranges = svg.children[1].children || [];
    const counties = (svg.children[2] && svg.children[2].children) || [];

    if (!styles || !ranges.length || !counties.length) {
      return <></>;
    }

    const stylesArray = styles.split('}') || [];

    const legendColors = [];
    stylesArray.forEach((item) => {
      const style = item.trim().match(/fill:(.*?);/) || [];
      if (style && style.length > 1) {
        legendColors.push(style[1]);
      }
    });

    const legendItems = legendColors.map((color, index) => {
      const rangeItem = ranges[index] ? ranges[index] : {};
      const rangeOriginal = (rangeItem.dataset ? rangeItem.dataset.range : '') || '';
      const isLast = legendColors.length === index + 1;
      const rangeDisplay = valueFormatFunc(rangeOriginal, isLast);
      const rangeId =
        rangeItem.classList && rangeItem.classList.length ? rangeItem.classList[0] : '';
      const rangeRaw = rangeOriginal.split('-');

      return {
        color,
        rangeRaw,
        rangeOriginal,
        rangeDisplay,
        rangeId,
      };
    });

    const legendLabels = legendLabelsCallback(legendItems);

    return (
      <div className={classes['county-map-legend-container']}>
        <ul className={classes['county-map-legend']}>
          {legendItems.map((legendItem) => {
            const { color, rangeDisplay, rangeId } = legendItem;
            const legendTooltipView = getLegendTooltipView(title, rangeDisplay);

            return (
              <li
                key={color}
                onClick={onLegendBarClick}
                onMouseOver={onLegendBarHover}
                onMouseLeave={onLegendBarLeave}
                style={{
                  backgroundColor: color,
                }}
                data-id={rangeId}
                className={classes['county-map-legend-item']}
              >
                {legendTooltipView}
              </li>
            );
          })}
        </ul>
        <div className={classes['county-map-description']}>{legendLabels}</div>
      </div>
    );
  };

  getLegendTooltipView = (title, value) => (
    <div className={classes['legend-item-tooltip']}>
      <p className={classNames(classes['legend-tooltip-title'], 'text-white')}>{title}</p>
      <p className={classNames(classes['legend-tooltip-value'], 'text-white')}>{value}</p>
    </div>
  );

  openEmbedWidgetPopup = (e) => {
    const { embedWidgetUrl, embedWidgetType, dispatchOpenEmbedWidgetPopup, name } = this.props;
    dispatchOpenEmbedWidgetPopup({
      type: embedWidgetType,
      url: embedWidgetUrl,
      name,
      openButtonRef: e.target,
    });
  };

  render() {
    const { getMapFooterView } = this;
    const mapFooterView = getMapFooterView();
    return mapFooterView;
  }
}

CountyMapFooter.propTypes = propTypes;
CountyMapFooter.defaultProps = defaultProps;

const mapStateToProps = ({ modals: { embedWidget } }) => {
  const { name: embedName, open } = embedWidget;
  return {
    embedName,
    isEmbedWidgetOpen: open,
  };
};

const mapDispatchToProps = {
  dispatchOpenEmbedWidgetPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(CountyMapFooter);
